import { sanitize } from 'indicative';

const sanitizationRules = {
  slug: 'slug',
};

export default {
  methods: {
    getSlug(string) {
      const sanitized = sanitize({
        slug: string,
      }, sanitizationRules);
      return sanitized.slug;
    },
  },
};
